import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { isNative } from './responsive';

export const useResize = () => {
  // eslint-disable-next-line
  const [ width, setWidth] = useState(window.innerWidth);
  const [isWidthBelowXSmall, setIsWidthBelowXSmall] = useState(window.innerWidth < 450);
  const [isWidthBelowSmall, setIsWidthBelowSmall] = useState(window.innerWidth < 640);
  const [isWidthBelowMedium, setIsWidthBelowMedium] = useState(window.innerWidth < 768);
  const [isWidthBelowLarge, setIsWidthBelowLarge] = useState(window.innerWidth < 1024);
  const [isWidthBelowXLarge, setIsWidthBelowXLarge] = useState(window.innerWidth < 1280);

  useEffect(() => {
    function watchWidth() {
      setWidth(window.innerWidth);
      setIsWidthBelowXSmall(window.innerWidth < 450);
      setIsWidthBelowSmall(window.innerWidth < 640);
      setIsWidthBelowMedium(window.innerWidth < 768);
      setIsWidthBelowLarge(window.innerWidth < 1024);
      setIsWidthBelowXLarge(window.innerWidth < 1280);
    }
    if (Platform.OS === 'web') {
      window.addEventListener('resize', watchWidth);
    }

    return function () {
      if (!isNative) {
        window.removeEventListener('resize', watchWidth);
      }
    };
  }, [
    isWidthBelowXLarge,
    isWidthBelowLarge,
    isWidthBelowMedium,
    isWidthBelowSmall,
    isWidthBelowXSmall,
  ]);

  return {
    isWidthBelowXSmall,
    isWidthBelowSmall,
    isWidthBelowMedium,
    isWidthBelowLarge,
    isWidthBelowXLarge,
  };
};
